  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">

        <iframe style="width:100%; height: 600px" [srcdoc]="data | safeHtml" >
            
          </iframe> 
       
      </div>
      <div class="modal-footer justify-content-between">

        <button type="button" class="btn btn-primary" (click)="closeModal()">
          Close
        </button>

      </div>
    </div>
  </div>
 